'use es6';

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { createStore, applyMiddleware, compose as _compose } from 'redux';
import { debug } from './env';
var compose = _compose;
export default (function (rootReducer, initialState, middleware, storeName) {
  if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && debug()) {
    compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      name: "MarketplaceUI" + (storeName ? "-" + storeName : '')
    });
  }

  var createStoreWithMiddleware = compose(applyMiddleware.apply(void 0, _toConsumableArray(middleware)))(createStore);
  return createStoreWithMiddleware(rootReducer, initialState);
});